import { render, staticRenderFns } from "./newsInfo.vue?vue&type=template&id=a6b1365c&scoped=true&"
import script from "./newsInfo.vue?vue&type=script&lang=js&"
export * from "./newsInfo.vue?vue&type=script&lang=js&"
import style0 from "./newsInfo.vue?vue&type=style&index=0&id=a6b1365c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b1365c",
  null
  
)

export default component.exports